@use "../../design-tokens/typography/typography" as *;
@use "@design/design-tokens/border-radius/border-radius" as *;

@layer design-system {
  .root {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .amberCircle {
    --node-accent: var(--border-primary);
    --node-default-fill: var(--surface-decorative-amber-default);
    --node-default-fill-opacity: 1;
  }

  .indigoTriangle {
    --node-accent: var(--kg-theme);
  }

  .purplePentagon {
    --node-accent: var(--purple-10);
  }

  .tealHexagon {
    --node-accent: var(--chart-multi-lines-hex-3);
  }

  .crimsonDiamond {
    --node-accent: var(--crimson-9);
  }

  .oliveCircle {
    --node-accent: var(--chart-multi-lines-hex-8);
  }

  .goldSquare {
    --node-accent: var(--chart-multi-lines-hex-4);
  }

  .shapeRoot {
    transform-box: fill-box;
    transform-origin: center;
    transition: transform 0.15s ease;

    // Caller-driven: non-interactive nodes are never put into the hover state.
    &[data-state="hover"] {
      transform: scale(1.2);

      .shape {
        fill: var(--node-accent);
        fill-opacity: 1;
      }
    }
  }

  .shapeOutline {
    fill: var(--background-default);
    stroke: var(--node-accent);
    stroke-width: 1;
    stroke-linejoin: miter;
  }

  // Inner: accent @ 50% (amber overrides via --node-default-*).
  .shape {
    fill: var(--node-default-fill, var(--node-accent));
    fill-opacity: var(--node-default-fill-opacity, 0.5);
    stroke: var(--background-default);
    stroke-width: 1;
    stroke-linejoin: miter;
    transition:
      fill 0.15s ease,
      fill-opacity 0.15s ease;
  }

  .active {
    box-sizing: border-box;
    border: 1px solid var(--node-accent);
    @include border-radius-full;
    background-color: var(--background-default);

    .activeBadge {
      @include typography-v2-ui-base;
      box-sizing: border-box;
      display: flex;
      flex-shrink: 0;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      @include border-radius-full;
      color: var(--icon-default);
      background-color: var(--node-accent);
      transition: box-shadow 0.15s ease;
    }

    &:hover .activeBadge {
      box-shadow: var(--elevation-strong);
    }
  }

  .letter {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    @include border-radius-full;
    color: var(--text-default);
    background: var(--node-accent);
    font-weight: 600;
  }
}
